"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _warning = _interopRequireDefault(require("warning"));

var _normalizr = require("normalizr");

var _actions = require("./actions");

var middlewareFactory = function (_ref) {
  var _ref$isDevEnv = _ref.isDevEnv,
      isDevEnv = _ref$isDevEnv === void 0 ? false : _ref$isDevEnv,
      _ref$schemas = _ref.schemas,
      schemas = _ref$schemas === void 0 ? {} : _ref$schemas;
  return function middleware(store) {
    return function (next) {
      return function (action) {
        var payload = action.payload,
            meta = action.meta; // --
        // -- NORMALIZING ENTITIES
        // --

        if (payload && payload.data && meta && meta.normalizeEntities && meta.entityType) {
          var schema = schemas[meta.entityType];

          if (schema) {
            var _normalize = (0, _normalizr.normalize)(payload.data, Array.isArray(payload.data) ? [schema] : schema),
                result = _normalize.result,
                entities = _normalize.entities;

            store.dispatch((0, _actions.entitiesReceive)(entities));
            return next((0, _extends2.default)({}, action, {
              payload: (0, _extends2.default)({}, payload, {
                entities: result
              })
            }));
          }
          /* istanbul ignore next */


          (0, _warning.default)(isDevEnv, `[entityType] There is no ${meta.entityType} schema on schemas.js`);
        } // --
        // -- REMOVING ENTITIES
        // --


        var needle = meta && meta.request && meta.request.needle;
        var entityType = meta && meta.entityType;
        var removeEntities = meta && meta.removeEntities;

        if (removeEntities && entityType && needle) {
          store.dispatch((0, _actions.entitiesRemove)(entityType, [needle]));
        }

        return next(action);
      };
    };
  };
};

var _default = middlewareFactory;
exports.default = _default;